import React from "react";
import {DragDropContext, Droppable} from "react-beautiful-dnd";
import DragAndDropItem from "./DragAndDropItem";


const DragAndDropComponent = ({header, onDragEnd, items, dropInfo = null}) => {
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId={"dropable"}>
                {(provided, snapshot) => (
                    <div className={"flex flex-col space-y-2"}>
                        {header}
                        <div {...provided.droppableProps} ref={provided.innerRef} className={"grid grid-cols-1 gap-2"}>

                            {items.map((item, index) => (
                                <DragAndDropItem dropInfo={dropInfo} key={item.key} component={item.component}
                                                 index={item.index} draggableId={item.draggableId}/>
                            ))}
                        </div>
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    )
}
export default DragAndDropComponent;
